import { render } from "./LeaveDurationInput.vue?vue&type=template&id=5caa9281&scoped=true"
import script from "./LeaveDurationInput.vue?vue&type=script&lang=js"
export * from "./LeaveDurationInput.vue?vue&type=script&lang=js"

import "./LeaveDurationInput.vue?vue&type=style&index=0&id=5caa9281&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caa9281"]])

export default __exports__